import { getI18nLocale, type Locale } from '@wecasa/i18n';

export type StripeLocale = Extract<Locale, 'fr' | 'en' | 'de'>;

// TODO I18N: Move this to backend?
const STRIPE_LOCALE_BY_LOCALE: Record<Locale, StripeLocale> = {
  fr: 'fr',
  'fr-CH': 'fr',
  en: 'en',
  de: 'de',
  'de-AT': 'de',
  'de-CH': 'de',
};

export const getStripeLocale = () => STRIPE_LOCALE_BY_LOCALE[getI18nLocale()];
